import React, {useState} from "react";
import {VerificationCodeInput} from '~/components';
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {combineConfig} from "@uiw/react-codemirror";

function Auth2FA(){
    const { id } = useParams();
    const [isComplete, setIsComplete] = useState(false);
    const [disableBtn, setDisableBtn] = useState(false);
    const [searchParams] = useSearchParams();
    const redirect = searchParams.get("redirect") || "/ai-chatbot";
    const navigate = useNavigate();
    const handleCallback = (res) => {
        if (res.data?.Succeeded){
            navigate(redirect, { replace: true });
        }
    }

    const handleOnVerifyCode = (isBefore) => {
        setIsComplete(!isBefore);
        setDisableBtn(isBefore);
    }
    return (
        <div className="px-xxl-5">
            <div className="text-center mb-6">
                <div className="text-center mb-6">
                    <h4 className="text-body-highlight mb-3">Enter the verification 2FA code</h4>
                    <p className="fs-8-1">Please enter the 6-digit verification code from your authenticator app to continue.</p>
                    <VerificationCodeInput
                        formId="formVerification"
                        onCompleteChange={(comp) => setIsComplete(comp)}
                        onCallback={handleCallback}
                        apiUrl={`/auth/signin-2fa/${id}`}
                        onVerifyCode = {handleOnVerifyCode}
                    />
                    <button disabled={!isComplete} type="submit" form="formVerification" className="btn btn-primary">
                        {
                            disableBtn && (
                                <span role="status" aria-hidden="true" className="spinner-border spinner-border-sm me-3"></span>
                            )
                        }
                        Verify Code</button>
                </div>
            </div>
        </div>
    )
}
export default Auth2FA